import { Component, Inject, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
// @ts-ignore
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { Observable, Observer, Subscription } from 'rxjs';
import { CustomerService } from 'src/app/core/services/customer.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ViewFilePdfComponent } from 'src/app/shared/components/view-file-pdf/view-pdf.component';
import { EnumFomatUploadFile, EnumTypeImage } from "src/app/core/constants/common";

export interface DialogData { }


@Component({
    selector: 'app-dialog-ai-recognition',
    templateUrl: './dialog-ai-recognition.component.html',
    styleUrls: ['./dialog-ai-recognition.component.scss']
})
export class DialogAIRecognitionComponent implements OnInit {
    isModeImage: 'normal' | 'preview' = 'normal';
    isLoading: boolean = false; // loading Data AI
    listImage: any[] = [
        {
            fileType: 'personal',
            fileName: '',
            fileContentBase64: '',
            fileTitle: this.message.getMessage('kyc.cmt_passport_cccd_front'),
            fileDescription: this.message.getMessage('kyc.cmt_passport_cccd_description_personal'),
            fileSize: 0,
            error: 0,
            documentType: 'MT',
            accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
            required: true,
            messageReuired: this.message.getMessage('kyc.cmt_passport_cccd_font_required')
        },
        {
            fileType: 'personal',
            fileName: '',
            fileContentBase64: '',
            fileTitle: this.message.getMessage('kyc.cmt_passport_cccd_back'),
            fileDescription: this.message.getMessage('kyc.cmt_passport_cccd_description_personal'),
            fileSize: 0,
            error: 0,
            documentType: 'MS',
            accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
            required: false,
            messageReuired: '',
        },
        {
            fileType: 'enterprise',
            fileName: '',
            fileContentBase64: '',
            fileTitle: this.message.getMessage('kyc.business_registration_certificate_1'),
            fileDescription: this.message.getMessage('kyc.cmt_passport_cccd_description_enterprise'),
            fileSize: 0,
            error: 0,
            documentType: 'GPKD',
            accept: EnumFomatUploadFile.UPLOAD_FILE,
            required: true,
            messageReuired: this.message.getMessage('kyc.business_registration_required'),
        },
        {
            fileType: 'enterprise',
            fileName: '',
            fileContentBase64: '',
            fileTitle: this.message.getMessage('kyc.business_registration_certificate_2'),
            fileDescription: this.message.getMessage('kyc.cmt_passport_cccd_description_enterprise'),
            fileSize: 0,
            error: 0,
            documentType: 'GPKD',
            accept: EnumFomatUploadFile.UPLOAD_FILE,
            required: false,
            messageReuired: '',
        }
    ];
    loading: boolean;
    customerForm = this.fb.group({
        customerType: new FormControl('personal'),
    });
    subcription: Subscription = new Subscription();
    @BlockUI() blockUI: NgBlockUI;
    public previewVisible: boolean;


    constructor(
        public dialogRef: MatDialogRef<DialogAIRecognitionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public dialog: MatDialog,
        private translateService: TranslateService,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private message: Message,
        private sanitizer: DomSanitizer,
        private customerService: CustomerService,
    ) {
        dialogRef.disableClose = false;
        this.previewVisible = false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if(this.listImageResponse && this.listImageResponse.length > 0) {
        //   this.getImageByUrl();
        // }
    }

    ngOnInit(): void { }

    getImageByUrl() {
        // let listApi = [];
        // this.listImageResponse.forEach(element => {
        //     listApi = [...listApi, this.customerService.getImageByPath(element.id)]
        // });
        // forkJoin(listApi).subscribe((response) => {
        //     response.forEach((item, index) => {
        //         this.downLoadFile(item, EnumTypeImage.JPEG, this.listImageResponse[index]);
        //     })
        // });
    }

    deleteImage(index) {
        this.listImage[index].fileContentBase64 = '';
        this.listImage[index].fileSize = 0;
    }

    handleChange(info: { file: NzUploadFile }, index: number): void {
        info.file['index'] = index
        switch (info.file.status) {
            case 'uploading':
                this.loading = true;
                break;
            case 'done':
                // Get this url from response in real world.
                this.getBase64(info.file.originFileObj, (img: string) => {
                    this.loading = false;
                    // this.fileUpload = info.file;
                    // this.avatarUrl = img;
                    this.listImage[index].fileContentBase64 = img;
                    this.listImage[index].fileName = info.file.name;
                    this.listImage[index].fileSize = info.file.size;
                    // if (this.customerForm.controls['customerType'].value === 'personal') {
                    //     const totalSize = this.listImage.reduce((accumulator, currentValue) => accumulator + currentValue.fileSize, 0);
                    //     if (totalSize >= 5242880) {
                    //         this.toastr.error(this.message.getMessage('messages.image_must_than_10m'));
                    //         this.deleteImage(index);
                    //     }
                    // } else {
                    //     if (info.file.size > 10485760) {
                    //         this.toastr.error(this.message.getMessage('messages.image_must_than_10m_only'));
                    //         this.deleteImage(index);
                    //     }
                    // }
                });
                break;
            case 'error':
                this.toastr.error('Network error');
                this.loading = false;
                break;
        }
    }

    handlePreview = async (file: NzUploadFile) => {
        this.previewVisible = true;
    }

    dummyRequest = ({ file, onSuccess, onError }) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
    };

    sanitize(url: string) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    private getBase64(img: File, callback: (img: string) => void): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result.toString()));
        reader.readAsDataURL(img);
    }

    beforeUpload = (file: NzUploadFile, fileList: NzUploadFile[]) => {
        return new Observable((observer: Observer<boolean>) => {
            const isJpegOrJpgOrPngOrBmp = file.type === EnumTypeImage.JPEG || file.type === EnumTypeImage.JPG || file.type === EnumTypeImage.PNG || file.type === EnumTypeImage.BMP;
            const isJpegOrJpgOrPngOrBmpOrPdf = file.type === EnumTypeImage.JPEG || file.type === EnumTypeImage.JPG || file.type === EnumTypeImage.PNG || file.type === EnumTypeImage.BMP || file.type === 'application/pdf';
            if (this.customerForm.controls['customerType'].value === 'personal') {
                if (!isJpegOrJpgOrPngOrBmp) {
                    this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg_bmp_jpeg'));
                    observer.complete();
                    return;
                }
            }
            if (this.customerForm.controls['customerType'].value === 'enterprise') {
                if (!isJpegOrJpgOrPngOrBmpOrPdf) {
                    this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg_bmp_jpeg_pdf'));
                    observer.complete();
                    return;
                }
            }
            if (this.customerForm.controls['customerType'].value === 'personal' && file.size >= 5 * 1024 * 1024) {
                this.toastr.error(this.message.getMessage('messages.error_file_upload_5mb'));
                observer.complete();
                return;
            }
            if (this.customerForm.controls['customerType'].value === 'enterprise' && file.size > 10 * 1024 * 1024) {
                this.toastr.error(this.message.getMessage('messages.image_must_than_10m_only'));
                observer.complete();
                return;
            }
            if (this.customerForm.controls['customerType'].value === 'personal') {
                observer.next(isJpegOrJpgOrPngOrBmp);
            } else {
                observer.next(isJpegOrJpgOrPngOrBmpOrPdf);
            }
            observer.complete();
        });
    }

    selectCustomerType(event: any) {
        this.customerForm.controls['customerType'].patchValue(event.value);
        this.listImage.forEach(e => {
            e.fileContentBase64 = '';
            e.fileSize = 0;
        });
    }

    onNoClick() {
        this.dialogRef.close();
    }

    AiIdentification() {
        let listTypeDocument = [];
        let listImageBase64 = [];
        const listImageUpload = this.listImage.filter(e => e.fileType === this.customerForm.controls['customerType'].value);
        if (listImageUpload[0].fileContentBase64.length === 0) {
            this.toastr.error(listImageUpload[0].messageReuired);
            return
        }
        listImageUpload.forEach(e => {
            if (e.fileContentBase64.length > 0) {
                listTypeDocument.push(e.documentType);
                listImageBase64.push(e.fileContentBase64.split(',')[1]);
            }
        })
        const body = {
            typeCustomer: this.customerForm.controls['customerType'].value === 'personal' ? 1 : 2,
            listTypeDocument,
            listImageBase64
        }
        this.blockUI.start();
        this.isLoading = true;
        setTimeout(() => {
            this.blockUI.stop();
        }, 100);

        this.subcription = this.customerService.genFileCustomer(body).subscribe(rs => {
            if (rs.success) {
                this.dialogRef.close({ data: rs.data, listImageUpload: listImageUpload  });
            } else {
                this.toastr.error(rs.message);
            }
            this.isLoading = false;
        });
    }

    toggleFullscreen(image, event) {
        event.stopPropagation();
        const img = image
        if (img.classList.contains('fullscreen')) {
            img.classList.remove('fullscreen');
            img.classList.add('small');
            this.isModeImage = 'normal';
        } else {
            img.classList.add('fullscreen');
            img.classList.remove('small');
            this.isModeImage = 'preview';
        }
    }

    previewPdf(dataFile: { fileName: string, filePathBase64: string }, event: any) {
        event.stopPropagation();
        const data = {
            filePathBase64: dataFile.filePathBase64.split(',')[1],
            fileName: dataFile.fileName,
          };

          const dialogRef = this.dialog.open(ViewFilePdfComponent, {
            width: '1000px',
            data,
          });
          dialogRef.afterClosed().subscribe(rs => {
          });
    }

    cancelAIRecognition() {
        this.subcription.unsubscribe();
        this.dialogRef.close();
    }

}


